import { register } from 'register-service-worker'
import config from 'config'
import { Logger } from '@vue-storefront/core/lib/logger'

const isProd =
  typeof process !== 'undefined' &&
  process.env &&
  process.env.NODE_ENV === 'production'

if (isProd || config.server.devServiceWorker) {
  register('/service-worker.js', {
    ready () {
      Logger.log(
        'App is being served from cache by a service worker.'
      )
    },
    cached () {
      Logger.log('Content has been cached for offline use.')()
    },
    updated () {
      Logger.log('New content is available; refresh when convenient.')()
    },
    offline () {
      Logger.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error (error) {
      Logger.error('Error during service worker registration:', error)()
    }
  })
}
